var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticle2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10V92C0 97.5229 4.47715 102 10 102H92C97.5229 102 102 97.5228 102 92V10C102 4.47715 97.5228 0 92 0H10ZM85 82.1667C85 83.7315 83.7315 85 82.1667 85H19.8333C18.2685 85 17 83.7315 17 82.1667C17 80.6019 18.2685 79.3333 19.8333 79.3333H82.1667C83.7315 79.3333 85 80.6019 85 82.1667ZM85 70.8333C85 72.3981 83.7315 73.6667 82.1667 73.6667H19.8333C18.2685 73.6667 17 72.3981 17 70.8333C17 69.2685 18.2685 68 19.8333 68H82.1667C83.7315 68 85 69.2685 85 70.8333ZM85 41C85 46.5228 80.5228 51 75 51H27C21.4772 51 17 46.5228 17 41V27C17 21.4772 21.4772 17 27 17H75C80.5228 17 85 21.4772 85 27V41Z",
    fill: "#f8f8f8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle2);
export default __webpack_public_path__ + "static/media/article2.2a4b29782d37257c9a1461513cef5fad.svg";
export { ForwardRef as ReactComponent };